module.exports = __webpack_public_path__ + "img/pasta-banner-h5-clean.2b03234c.png";